// OS-banner copy for an agent permission request. The banner persists in the OS notification
// center, so it NEVER carries the request's title/input (a Codex title is the full command and
// can hold secrets): only a generic label chosen from the tool name.
export function bannerToolLabel(name: string | null | undefined): string {
  const n = name ?? "";
  if (/^(bash|shell|exec|command|run)/i.test(n)) return "Run command";
  if (/(edit|write|patch|apply|create|delete|remove)/i.test(n)) return "Edit file";
  return "Tool request";
}
